import React from 'react';

// import { UserOutlined } from '@ant-design/icons';
import styled from '@emotion/styled';

import {
 PrimaryBlackButton,
} from '../../components/Button/Buttons';
import CompanyLogo from '../../components/CompanyLogo/CompanyLogo';
import HamburgerIcon from '../../components/Icons/HamburgerIcon';
// import { configSetting } from '../../config';
import Nav from '../nav/Nav';
import { useNavigate } from 'react-router-dom';
import { CONTACT } from '../../routes/routeConstants';

interface IHeader {
 open: boolean;
 toggleNav: (...arg: any) => void;
}

export const Header: React.FC<IHeader> = ({ open, toggleNav }) => {
 const navigate = useNavigate();
 return (
  <StyledHeader>
   <Container>
    <CompanyLogo />
    <Nav />
    <Flex>
     <PrimaryBlackButton
      onClick={() => {
       navigate(`/${CONTACT}`);
      }}
     >
      Contact Us
     </PrimaryBlackButton>
    </Flex>
   </Container>
   {/* <Container className='small-gap'>
        <TertiaryButton
          onClick={() => {
            window.location.href = configSetting.dashboardUrl;
          }}
        >
          <UserOutlined />
          Sign In
        </TertiaryButton>

      </Container> */}
   <HamburgerIconContainer>
    <CompanyLogo smallLogo />
    <div onClick={() => toggleNav()}>
     <HamburgerIcon />
    </div>
   </HamburgerIconContainer>
  </StyledHeader>
 );
};

const Container = styled.div`
 display: flex;
 width: 100%;
 align-items: center;
 justify-content: space-between;
 gap: 80px;

 &.small-gap {
  gap: 40px;
 }

 @media (max-width: 884px) {
  display: none;
 }
`;

const StyledHeader = styled.header`
 display: flex;
 padding: 1rem 5.4375rem;
 justify-content: space-between;
 align-items: center;
 box-shadow: 0px 2px 10px 0px #00000016;
 position: -webkit-sticky; /* For Safari */
 position: sticky;
 top: 0;
 background-color: white;
 z-index: 1000;
 /* border: 2px solid green; */

 @media (max-width: 884px) {
  height: 60px;
  padding: 0;
  padding: 8px 24px;
 }
`;

const HamburgerIconContainer = styled.div`
 display: None;

 @media (max-width: 884px) {
  display: flex;
  cursor: pointer;
  /* margin-left: auto; */
  justify-content: space-between;
  align-items: center;
  /* border: 2px solid red; */
  width: 100%;
 }
`;

const Flex = styled.div`
 display: flex;
 align-items: center;
 gap: 12px;
`;
